// extracted by mini-css-extract-plugin
module.exports = {"root":"TablePerspectiveDirector_root__2iH1h"};